@if (products && products.length > 0) {
  <div class="compare-product">
    <div class="row compare-product__title">
      <div class="col-12 col-md-2">
        <p>Product</p>
      </div>
      <div class="col-12 col-md-10">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4 col-lg-5 col-xl-6">
            <p>Description</p>
          </div>
          <div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
            <p>Size</p>
          </div>
          @if (userPermissionService.showPrice) {
            <div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
              <p>Price</p>
            </div>
          }
          <div class="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-2"></div>
        </div>
      </div>
    </div>
    @for (product of products; track product; let last = $last) {
      <app-custom-product-list-item
        [compare]="false"
        [product]="product"
        [ngClass]="{ last: last }"
      ></app-custom-product-list-item>
    }
  </div>
}
<div [style.display]="noProductCode ? 'block' : 'none'">
  <app-error [errorMessage]="errorMessage"></app-error>
</div>
